export default __webpack_public_path__ + "static/media/github.657f528a.svg";